import { render } from "./Printers.vue?vue&type=template&id=73afd294"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"
script.render = render

export default script